var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 27",
    style: {
      enableBackground: "new 0 0 130 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000127001989891354705830000007734512303495215782_);}\n\t.st1{fill:#8B3FFD;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 130,
    height: 27
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133516079917303173310000001680265952146967425_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000133516079917303173310000001680265952146967425_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,0c-7.6,0-13.7,6.1-13.7,13.5C11.1,21,17.3,27,24.8,27c7.5,0,13.7-6.1,13.7-13.5C38.5,6.1,32.3,0,24.8,0 z M24.8,18.5c-2.8,0-5.1-2.3-5.1-5s2.3-5,5.1-5s5.1,2.3,5.1,5S27.7,18.5,24.8,18.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.1,3.9v19.7H6.2L0,3.9H11.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.3,7.4l-3,7.3c-0.1,0.1-0.1,0.3-0.1,0.3l-0.1,0.2l-0.1-0.2c0-0.1-0.1-0.3-0.1-0.3l-3-7.3h-3.9l5.1,12.6 l-2.2,4.8h3.9L130,7.5L126.3,7.4L126.3,7.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.6,8.1C96.9,7.6,96,7.3,95,7.2c-1.7-0.2-3.4,0.4-4.5,1.5V7.4H87v12.6h3.6v-6.6c0-1.5,0.3-1.9,0.5-2.2 c0.4-0.7,1.2-1,2.2-1c0.9,0,1.8,0.4,2.2,1.1c0.3,0.5,0.4,1.2,0.4,1.5c0,1.1,0,7.2,0,7.2h3.6v-7.6C99.3,10.3,98.7,9,97.6,8.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.2,7.5c-1.7-0.6-3.6-0.5-5.4,0.3c-1.1,0.5-2.2,1.4-2.8,2.5c-0.6,0.9-0.9,2.1-0.9,3.4s0.3,2.5,0.9,3.4 c0.6,0.9,1.4,1.8,2.4,2.3c1.1,0.5,2.2,0.9,3.4,0.9c0.6,0,1.2-0.1,1.8-0.3c0.5-0.2,1.1-0.3,1.6-0.6c1.1-0.6,1.9-1.4,2.4-2.3 c0.6-0.9,0.9-2.1,0.9-3.4C84.7,10.8,83,8.5,80.2,7.5z M81.3,13.8c-0.1,1.1-0.4,2.1-1.1,2.6c-0.5,0.4-1.3,0.7-2.2,0.8 c-0.9,0-1.6-0.3-2.2-0.8c-0.7-0.6-1-1.5-1.1-2.6c-0.1-1.3,0.4-2.3,1.4-3c0.5-0.3,1.2-0.6,1.9-0.6c0.8,0,1.4,0.3,2,0.6 C80.9,11.4,81.4,12.6,81.3,13.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.2,8.1c-0.7-0.5-1.6-0.9-2.6-0.9c-0.2,0-0.4,0-0.6,0c-1.4,0-2.6,0.6-3.6,1.8l-0.2,0.3h-0.4 c-0.3-0.4-0.6-0.8-0.9-1c-0.7-0.5-1.6-0.9-2.6-0.9c-1.6-0.2-2.9,0.3-4.1,1.5V7.6h-3.6v12.6h3.6v-6.6v-0.2c0-1.4,0.2-1.7,0.4-2.1 c0.4-0.7,1.2-1.1,2.1-1c0.9,0,1.6,0.4,2.1,1.1c0.3,0.5,0.3,1.1,0.3,1.7v7h3.6v-6.8c0-1.3,0.2-1.7,0.4-2.1c0.4-0.7,1.2-1,2.1-1 c0.9,0,1.6,0.4,2,1.1c0.3,0.4,0.3,0.9,0.3,1.3c0,0.2,0,0.3,0,0.4v7h3.6v-7.7c0-0.7-0.1-1.4-0.3-2C68.5,9.4,68,8.6,67.2,8.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.6,16.1c-0.5,0.5-1.7,1.5-3.4,1.5c-1.4,0.1-2.4-0.3-3.2-1.1c-0.4-0.3-0.6-0.9-0.8-1.4h9.8v-0.1 c0.1-0.5,0.2-0.9,0.2-1.5c0-0.4-0.1-1-0.3-1.8c-0.4-1.5-1.3-2.6-2.4-3.4c-1.3-0.9-2.5-1.2-2.9-1.2c-2.5-0.4-5.4,0.7-6.8,3 c-1.1,1.6-0.9,3.2-0.9,3.8c0,0.6,0.1,2.5,1.6,4.2c1.8,2,4.3,2.1,5.1,2.1c3.4,0.1,5.8-2.1,6.3-2.5L112.6,16.1z M106.6,10.8 c0.5-0.3,1.1-0.6,1.9-0.6s1.4,0.3,2,0.6c0.5,0.4,0.9,0.9,1.2,1.5h-6.2C105.6,11.8,106,11.2,106.6,10.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyLogo);
export default __webpack_public_path__ + "static/media/Ю-money_logo.58f9adcb6b8386c8b1620e9350a11914.svg";
export { ForwardRef as ReactComponent };